import React from 'react'
import { offlineUsers, userList } from './mock'
import { FollowButton } from './follow'

export const UsersList = () => {

    const [data] = React.useState(offlineUsers)
    
    return (
        <div  className="users_list">
            <ul>
              {false && userList?.length >0 && userList.map((item,i)=>(
                 <UserItem key={'user_list'+i} user={item} />
               ))}

               {data?.length >0 && data.map((item,i)=>(
                 <UserItem key={'user_item'+i} user={item} />
                ))}
           
            </ul>
        </div>
    )
}


export const UserItem = ({user}) =>{

    return (
        <li>
            <a href={`/users/${user._id}`}>
                {user.avatar ? <img alt="avatar" src={`/assets/images/faces/${user.avatar}.png`} style={{border:`5px solid ${user.active && 'lightgreen'}`, borderRadius:'50%', }} className={`${user.active && 'online'}`} /> : <img alt="avatar" src="/faces/default.svg" /> }
                <div>
                    <div className="flex-start">
                        <h3 className="title">{user.name}</h3> 
                        {user.active && (
                            <React.Fragment> 
                            <small style={{color:'green', padding:'3px 5px', background:'lightgreen',borderRadius:'10px', marginLeft:'7px'}}> {user.active && 'online'} </small> 
                            </React.Fragment>)
                        } 
                    </div>
                    <b  className="position"></b>
                    <p  className="description">{user.email}</p>
                </div>
            </a>
            <div>
                <FollowButton 
                    id={user._id}
                    button={user.active}
                />
            </div>
        </li>
    )
}

